// Brain Dump Wrapper - Handles auth gate before showing the brain dump page

import { useState } from 'react';
import { brainDumpService } from '../services/brainDump';
import { BrainDumpLoginPage } from './BrainDumpLoginPage';
import { BrainDumpPage } from './BrainDumpPage';

export function BrainDumpWrapper() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    brainDumpService.isAuthenticated(),
  );

  if (!isAuthenticated) {
    return (
      <BrainDumpLoginPage onAuthenticated={() => setIsAuthenticated(true)} />
    );
  }

  return <BrainDumpPage />;
}
